/**
 * BaseButton is not to be used directly.
 * Instead, use one of other button types that implement it.
 */

export const BUTTON_SIZE_MAP = {
	DEFAULT: `input f5 ph4`,
	SMALL: `input-small f6 ph3`,
	LARGE: `input-large f4 ph5`,
	SQUARE: 'text-xl p-1 flex iconbutton',
	CIRCLE: 'f6 pa2 flex br-100 iconbutton',
	ICON: 'input f5 ph3',
	CHECK: 'f3 pa0 iconbutton'
};

export type ButtonSize = keyof typeof BUTTON_SIZE_MAP | null;

const PRIMARY_STYLES =
	'bg-theme-primary theme-white hover-theme-white bn hover-bg-theme-primary-dark active-bg-theme-primary-dark shadow-primary font-medium!';

export const BUTTON_STYLE_MAP = {
	PRIMARY: PRIMARY_STYLES,
	PRIMARY_ACCENT: `${PRIMARY_STYLES} + shadow-primary-accent active-bg-theme-primary-darker `,
	SECONDARY:
		'font-medium! bn bg-theme-white theme-primary-dark hover-bg-theme-white hover-theme-primary active-theme-primary-darker shadow-secondary',
	INTERNAL: 'font-medium! bn bg-theme-internal theme-internal-lighter hover-bg-theme-internal-dark shadow-internal',
	GREY: 'font-medium! bg-theme-grey theme-white b--theme-grey hover-bg-theme-grey-darker',
	ICON: 'bg-theme-white theme-grey b--theme-grey-light hover-theme-primary active-theme-primary-darker',
	DANGER: 'font-medium! bw1 bg-theme-white theme-error b--theme-error hover-bg-theme-error hover-theme-white hover-b--theme-error active-b--theme-error active-theme-error',
	INTERNAL_ICON: 'bg-theme-white active-bg-theme-white hover-bg-theme-internal-lighter theme-black bn theme-luxury:focus:focus-ring!',
	INTERNAL_SECONDARY: 'font-medium! bn bg-theme-white theme-internal-dark active-theme-internal-darker shadow-internal-secondary',
	TERTIARY: 'font-medium! bn bg-theme-white theme-primary-dark hover-bg-theme-primary-lighter btn-tertiary',
	INTERNAL_TERTIARY:
		'font-medium! bn bg-theme-white theme-internal-dark hover-bg-theme-internal-lighter active-bg-theme-internal-light btn-internal-tertiary',
	// This will replace usages of TextButton. Expectation is that only this and the TERTIARY_GREY buttons will be text only
	TERTIARY_GREY: 'theme-luxury:button-tertiary-grey!'
};

export type ButtonStyle = keyof typeof BUTTON_STYLE_MAP;
